<template>
  <b-button
    v-b-tooltip.hover.viewport.noninteractive="{title: text, disabled: !icon}"
    variant="primary"
    @click="toggleSelection"
  >
    <img
      v-if="icon"
      src="/img/icons/select-all.svg"
      alt="select-all-icon"
    >
    <template v-else>
      {{ text }}
    </template>
  </b-button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SelectAllObjectsButton',

  props: {
    icon: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('layout', [
      'allObjectsAreSelected',
      'selectedInstance',
    ]),
    text () {
      return this.allObjectsAreSelected ? 'Unselect All' : 'Select All'
    },
  },

  methods: {
    toggleSelection () {
      const objects = this.selectedInstance.canvas.getObjects()

      if (this.allObjectsAreSelected) {
        this.selectedInstance.canvas.discardActiveObject()
      } else if (objects.length) {
        this.selectedInstance.canvas.discardActiveObject()
        const selection = new fabric.ActiveSelection(objects, {
          canvas: this.selectedInstance.canvas
        })
        this.selectedInstance.canvas.setActiveObject(selection)
      }

      this.selectedInstance.canvas.requestRenderAll()
    },
  },
}
</script>

<style scoped lang="scss">
img {
  width: 1.5rem;
  scale: 2;
}
</style>
